import { ID } from '../../utils/codecUtils';
import { organizationGroupSchema } from '../models/organizationGroup.schema';

export const get = (organizationGroupId: ID) => {
  return {
    endpoint: `/organization_groups/${organizationGroupId}`,
    method: 'GET',
    responseSchema: organizationGroupSchema,
  } as const;
};
